/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Shop_Group_Story_MissingInputs */

const vi_shop_group_story_missing = /** @type {(inputs: Shop_Group_Story_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Không có mục Câu chuyện nào có đường dẫn "${i?.slug}". Chọn lại câu chuyện hoặc bỏ chọn.`)
};

/**

* @param {Shop_Group_Story_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story_missing = /** @type {((inputs: Shop_Group_Story_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Story_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story_missing(inputs)
});